import { MS_PER_YEAR } from "./constants";
export function calculateAnnualizedRewardAmount(amountPerBlock, blockTimeMs) {
    const blocksPerYear = MS_PER_YEAR.div(blockTimeMs);
    return amountPerBlock.mul(blocksPerYear);
}
//# sourceMappingURL=rewards.js.map